import React from 'react'
import PropTypes from 'prop-types'
import InputLabel from '@mui/material/InputLabel'
import Button from '@mui/material/Button'
import { makeStyles } from '@mui/styles'
import useTranslation from '../../hooks/useTranslation'

const useStyles = (store) => makeStyles(() => {
  const normalFontsFamily = 'NormalFonts'
  let boldFontsFamily = normalFontsFamily

  if (store.bold_fonts) {
    boldFontsFamily = 'BoldFonts'
  }

  return {
    container: {
      padding: '15px',
      width: '100%',
      height: '100%',
      background: '#fff',
      borderRadius: '1px',
      boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
      display: 'inline-block',
    },
    textContainer: {
      borderRadius: '2px',
      color: store.text_color,
      fontFamily: `'${normalFontsFamily}', 'Helvetica Neue', 'inherit'`
    },
    primaryButton: {
      backgroundColor: store.primary_color,
      color: store.secondary_color,
      borderRadius: '2px',
      padding: '10px 20px',
      marginTop: '10px',
      fontFamily: 'inherit',
      '&:hover': {
        backgroundColor: store.primary_color,
      }
    },
    h1: {
      fontFamily: `'${boldFontsFamily}', 'Helvetica Neue', 'inherit'`
    },
    h2: {
      fontFamily: `'${boldFontsFamily}', 'Helvetica Neue', 'inherit'`
    },
    thumb: {
      height: 'auto',
      maxWidth: '100%',
    }
  }
})

const ThemePreview = ({ store }) => {
  const { t } = useTranslation()
  const classes = useStyles(store)()

  const boldFonts = store.bold_fonts ? `
    @font-face {
      font-family: 'BoldFonts';
      font-style: normal;
      font-weight: normal;
      src: local('BoldFonts'), url('${store.bold_fonts}');
    }
  ` : ''

  const fontsCSS = `
    @font-face {
      font-family: 'NormalFonts';
      font-style: normal;
      font-weight: normal;
      src: local('NormalFonts'), url('${store.normal_fonts}');
    }
    ${boldFonts}
  `

  return (
    <>
      <style>{store.use_custom_fonts && store.normal_fonts ? fontsCSS : ''}</style>
      <InputLabel>{t('labels.theme_settings.theme_preview')}</InputLabel>
      <div className={classes.container}>
        <div className={classes.textContainer}>
          <h1 className={classes.h1}>{t('labels.theme_settings.heading1')}</h1>
          {t('labels.theme_settings.preview_text')}
          <hr />
          <h2 className={classes.h2}>{t('labels.theme_settings.heading2')}</h2>
          {t('labels.theme_settings.button_preview_text')}
          <Button variant="contained" className={classes.primaryButton}>
            {t('labels.theme_settings.button_example')}
          </Button>
        </div>
      </div>
    </>
  )
}

ThemePreview.propTypes = {
  store: PropTypes.object.isRequired
}

export default ThemePreview